// Staff-Backoffice und Kundenportal sind zwei Apps auf einer Origin (getrennte
// Webpack-Entries, kein vue-router — geroutet wird ueber window.location.pathname).
// Jede bekommt ihren eigenen Token-Slot, damit ein Kunden-Login die Staff-Session
// nicht verdraengt und umgekehrt: wer fuer beide Seiten arbeitet, bleibt in beiden
// gleichzeitig eingeloggt.
//
// Der Staff-Slot heisst weiterhin 'user' — bestehende Sessions bleiben ueber den
// Deploy hinweg gueltig, und Direktleser von localStorage['user'] auf Staff-Seiten
// verhalten sich unveraendert.
const STAFF_KEY = 'user';
const PORTAL_KEY = 'portalUser';

export const isPortalContext = function () {
    return window.location.pathname.startsWith('/client-portal');
};

export const sessionKey = function () {
    return isPortalContext() ? PORTAL_KEY : STAFF_KEY;
};

export const getSession = function () {
    try {
        return JSON.parse(localStorage.getItem(sessionKey()));
    } catch (e) {
        return null;
    }
};

export const setSession = function (data) {
    localStorage.setItem(sessionKey(), JSON.stringify(data));
};

export const clearSession = function () {
    localStorage.removeItem(sessionKey());
};

// Gibt es (unabhaengig von der aktuellen Seite) eine Session der anderen Seite?
// Fuer Quer-Links "Zum Backoffice" / "Zum Kundenportal".
export const hasSession = function (which) {
    return !!localStorage.getItem(which === 'portal' ? PORTAL_KEY : STAFF_KEY);
};

// Rollen aus dem JWT lesen. Staff-Tokens tragen ROLE_USER/ADMIN/…, Kunden-Tokens
// ROLE_PORTAL. Rein clientseitig und ungeprueft — reicht, um einen Token dem
// richtigen Slot zuzuordnen, ist aber keine Autorisierung.
const rolesInToken = function (token) {
    try {
        let b64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) b64 += '=';
        return JSON.parse(atob(b64)).roles || [];
    } catch (e) {
        return [];
    }
};

// Einmalige Migration: vor der Trennung schrieben Staff- und Portal-Login beide nach
// localStorage['user']. Ohne diesen Schritt wuerde der Deploy jeden Portal-Kunden
// ausloggen — und der zurueckbleibende Eintrag im Staff-Slot saehe aus wie eine
// Backoffice-Session (falscher "Zum Backoffice"-Link). Wird aus bootstrap.js vor dem
// ersten authHeader()-Aufruf gerufen; nach einem Durchlauf pro Browser ein No-op.
export const migrateLegacySession = function () {
    const raw = localStorage.getItem(STAFF_KEY);
    if (!raw) {
        return;
    }

    let stored;
    try {
        stored = JSON.parse(raw);
    } catch (e) {
        return;
    }
    if (!stored || !stored.token || !rolesInToken(stored.token).includes('ROLE_PORTAL')) {
        return;
    }

    // Ein Kunden-Token im Staff-Slot gehoert dort nicht hin. Nur uebernehmen, wenn im
    // Portal-Slot noch nichts liegt — eine echte Portal-Session nie ueberschreiben.
    if (!localStorage.getItem(PORTAL_KEY)) {
        localStorage.setItem(PORTAL_KEY, raw);
    }
    localStorage.removeItem(STAFF_KEY);
};

export const SESSION_KEYS = { STAFF_KEY, PORTAL_KEY };
